var _path, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckWithCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.0752 24.1211",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Check with Circle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "twoTonePrimary",
    d: "M12.0604.1708C5.516.1708.2106,5.483.2106,12.0358s5.3054,11.8651,11.8498,11.8651,11.8498-5.3122,11.8498-11.8651S18.6049.1708,12.0604.1708ZM11.9916,22.7821c-5.8894,0-10.6637-4.7805-10.6637-10.6774S6.1022,1.4273,11.9916,1.4273s10.6636,4.7804,10.6636,10.6774-4.7743,10.6774-10.6636,10.6774Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "twoTonePrimary",
    points: "17.3495 7.7053 16.1339 7.0277 11.6033 14.8998 7.7416 11.0984 6.7521 12.0752 11.9123 17.1552 17.3495 7.7053"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckWithCircle);
export default __webpack_public_path__ + "static/media/Check-with-circle.a4a48d93c7d88a33c9edf84d444087a0.svg";
export { ForwardRef as ReactComponent };